import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Illustration from '../components/illustrations/Illustration';

export class ConfirmationCheckmark extends Component {
  render() {
    return (
      <div>
        <input
          type="hidden"
          id="confirmationNumber"
          defaultValue={this.props.confirmationNumber}
        />
        <div>
          <div className="confirmation_img_holder center-block">
            <Illustration type="success" size="medium" />
          </div>
        </div>
      </div>
    );
  }
}

export default ConfirmationCheckmark;

ConfirmationCheckmark.propTypes = {
  confirmationNumber: PropTypes.string,
};
